
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageAfterOut: function () {
      window.overrideBackButton = null;
    },
    pageAfterIn: function () {
      var self = this;
      var app = self.$app;

      if (self.preventBack) {
        window.overrideBackButton = function () {
          app.toast.create({
            text: 'Please set a new password in order to proceed.',
            closeTimeout: 2000
          }).open();
        };
      }
    }
  },
  methods: {
    change: function () {
      var self = this;
      var app = self.$app; //console.log(self.$app.form.convertToData("#change-password-form"));

      app.dialog.confirm("Are you sure you want to change your password?", function () {
        self.$app.request({
          url: Url.to("user/password-multi-db"),
          method: "POST",
          data: self.$app.form.convertToData("#change-password-form"),
          success: function (data, status, xhr) {
            //console.log(data, status, xhr);
            self.$app.dialog.alert('Password changed successfully', function () {
              self.$router.back();
            });
          }
        });
      });
    }
  },
  id: 'fddcba5ca1',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar navbar-extra-large ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.preventBack, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'no-swipeback';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '" data-name="change-password">\n        <div class="navbar navbar-large navbar-extra-large">\n            <div class="navbar-bg bg-color-white"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.preventBack, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <a href="#" class="link back icon-only">\n                        <i class="icon icon-back"></i>\n                    </a>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </div>\n                <div class="title">Change password</div>\n                <div class="right">\n                </div>\n                <div class="title-large">\n                    <div class="title-large-text">\n                        Account\n                        <div class="subtitle-text">Change password</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="page-content">\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.extraMessage, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="block">\n                ';
          r += c(ctx_2.extraMessage, ctx_2);
          r += '\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            <div class="list no-hairline-top no-hairline-bottom" id="change-password-form">\n                <ul>\n                    <li class="item-content item-input item-input-with-info">\n                        <div class="item-inner">\n                            <div class="item-title item-floating-label">Current password</div>\n                            <div class="item-input-wrap">\n                                <span class="password-view-button"></span>\n                                <input type="password" name="current_password" placeholder="Enter your current password" required validate>\n                                <!--<div class="item-input-info">Default "required" validation</div>-->\n                            </div>\n                        </div>\n                    </li>\n\n                    <li class="item-content item-input item-input-with-info">\n                        <div class="item-inner">\n                            <div class="item-title item-floating-label">New password</div>\n                            <div class="item-input-wrap">\n                                <span class="password-view-button"></span>\n                                <input type="password" name="password_input" placeholder="Enter a new password" required validate>\n                            </div>\n                        </div>\n                    </li>\n                    <li class="item-content padding-top">\n                        <div class="item-inner">\n                        <div class="item-input-wrap">\n                            <div class="item-input-info no-margin">\n                                Your password must be at least 8 characters long and must contain an uppercase character (A-Z), a lowercase character (a-z) and a digit (0-9).\n                            </div>\n                        </div>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n\n            <div class="block no-margin-top">\n                <button @click="change" class="button button-large button-fill">Save new password</button>\n            </div>\n            <div class="block text-align-center">\n                <button class="button button-right display-inline login-screen-open"\n                        data-login-screen="#forgot-password-screen">\n                    Forgot your password?\n                </button>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    